import { render, staticRenderFns } from "./GroupByBroadcastInfo.vue?vue&type=template&id=1b4815aa&scoped=true&"
import script from "./GroupByBroadcastInfo.vue?vue&type=script&lang=js&"
export * from "./GroupByBroadcastInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupByBroadcastInfo.vue?vue&type=style&index=0&id=1b4815aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4815aa",
  null
  
)

export default component.exports